const apiUrl = process.env.REACT_APP_API_URL;

export const DeleteJunitEnviament = async (idEnviament: string) => {
    try {
        const url = `${apiUrl}:8061/jutge/junit/enviament/${idEnviament}`;
        const response = await fetch(url, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        if (response.ok) {
            return true;
        } else {
            throw new Error('Error deleting enviament');
        }
    } catch (error) {
        console.error("Error deleting junit enviament:", error);
        throw error;
    }
}
